import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SystemProvider } from './context/SystemContext';
import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <SystemProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </SystemProvider>
  </React.StrictMode>
);

reportWebVitals();
